import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import JointLogo from "./JointLogo";
import Footer from "./Footer";
import sbi from "../images/sbi.svg";
import bank from "../images/DefaultBank.svg";
import { useNavigate } from "react-router-dom";
import {
  ConsentRequestDetail,
  UserLinkedAccountHeader,
  ConsentApprovalHeader,
  ConsenthandleStatusCheck
} from "../helper/HeaderMakerforSocket";
import { useMyContext } from "../../AppContext";
import { toast } from "react-toastify";
import {
  ConvertDatetoStandard,
  FilterFipDetails,
} from "../helper/Commonfunctions";
import { UserLinkedAccountApi, ConsentApprove } from "../Apiservices";
import mixpanel from "mixpanel-browser";
import { Loader } from "../helper/Loader";
import { ImagesURL as ImagesURLFUNC } from "../helper/Commonfunctions";

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, { debug: true });

export default function ConfirmConsent() {
  const navigate = useNavigate();
  const [Pendingrequest,SetPendingRequest]=useState(false);
  const ImagesURL=ImagesURLFUNC();

  const [Bankinfo, SetBankinfo] = useState([]);
  const { Storage, SetStorage } = useMyContext();
  const [ConsentDetail, SetConsetDetail] = useState();

  const mydots=['.','..','...']
  const [Index,SetIndex]=useState(-1);
  



  useEffect(() => {

    if(Storage.Socketconnnection==null)
    {
 
        localStorage.clear();
        window.open(process.env.REACT_APP_CLOSING_URL, "_self");    
    }
    else{

    mixpanel.track("Viewed_BS_Consent_Page", {
      Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
      user_type:localStorage.getItem('user_type')
    });
   
    HandleConfirmRequestDetail();
  }
  }, []);

  const HandleUserLinkedAccounts = () => {
    UserLinkedAccountHeader.sid = Storage.sessionid;
    const message = {
      header: UserLinkedAccountHeader,
      payload: {
        userId: Storage?.userid,
      },
    };
    const Socketconnnection = Storage.Socketconnnection;

    if(!Socketconnnection)
    {
      localStorage.clear();
      window.open(process.env.REACT_APP_CLOSING_URL, "_self");
    }
    else{
      Socketconnnection.onclose = () => {
        localStorage.removeItem('insession');
        toast.error("Your session is expired. Please try again");
        setTimeout(() => {

          localStorage.clear();
          window.open(process.env.REACT_APP_CLOSING_URL, "_self");

          }, 1000);
        };
        
        // console.log("linked account ");
        Socketconnnection.send(JSON.stringify(message));
        SetPendingRequest(true);
        Socketconnnection.onmessage = (event) => {
          const receivedMessage = JSON.parse(event.data);
          SetBankinfo(receivedMessage?.payload?.LinkedAccounts);
          
          // console.log("received message ", receivedMessage);
          if(receivedMessage?.payload?.status=='FAILURE')
          {
            SetPendingRequest(false);
              navigate('/finalresult');
          }
          else{
            HandleUserSaveDetailUserLinkkedAccount(receivedMessage);
          }
        };
      };
    }
  const HandleUserSaveDetailUserLinkkedAccount = (receivedMessage) => {
    const message = {
      userId: Storage?.userid,
      data: receivedMessage,
    };
    // console.log(message);
    UserLinkedAccountApi(message)
      .then((response) => {
        if (response.status == 200) {
          // toast.success("saved");
          SetPendingRequest(false);
        }
      })
      .catch((error) => {
        SetPendingRequest(false);
    if(error?.response?.status==401)
    {
    toast.error("Your session is expired. Please try again");

    setTimeout(()=>{
      localStorage.clear();
      window.open(process.env.REACT_APP_CLOSING_URL, "_self");

    },1000)
  }else{
    Storage.internalservererror=true;
    SetStorage(Storage);
    navigate('/finalresult');
    
  }
      });
  };
  const HandleConfirmRequestDetail = () => {
    ConsentRequestDetail.sid = Storage.sessionid;
    // console.log(Storage);

    const message = {
      header: ConsentRequestDetail,
      payload: {
        consentHandleId: Storage?.consentHandle,
        userId: Storage?.userid,
      },
  
    };
    const Socketconnnection = Storage.Socketconnnection;
    if(!Socketconnnection)
    {

      localStorage.clear();
      window.open(process.env.REACT_APP_CLOSING_URL, "_self");

    }
    else{
        Socketconnnection.onclose = () => {
          toast.error("Your session is expired. Please try again");
            localStorage.removeItem('insession');
            setTimeout(() => {
                // window.location.href = `/?token=${localStorage.getItem("access_token")}`;

                localStorage.clear();
                window.open(process.env.REACT_APP_CLOSING_URL, "_self");

                }, 1000);
            };   
            Socketconnnection.send(JSON.stringify(message));

            Socketconnnection.onmessage = (event) => {

                const receivedMessage = JSON.parse(event.data);
                SetConsetDetail(receivedMessage?.payload);

              
                if(receivedMessage?.payload?.status=='FAILURE')
                {
                    navigate('/finalresult');
                }
                else{
                  Storage.fiu_id=receivedMessage?.payload?.FIU?.id;

                  SetStorage(Storage);

                  HandleUserLinkedAccounts();
                }
            };
        }
        };
  const HandleSubmitConsentApprovaltoBackend = (Nooftimesapicalled=1) => {
    SetPendingRequest(true);
    ConsentApprove(Storage?.consentHandle, Storage?.userid)
      .then((response) => {
        if (response?.status == 200) {
          // console.log(response.data);

         
          // Storage.finalConsentApproval = true;
          // SetStorage(Storage);
          // navigate("/finalresult");

         if(response?.data?.status=='SUCESS')
         {

          SetPendingRequest(false);
          Storage.redirecttounderreview=true
          Storage.finalConsentApproval=true
          SetStorage(Storage);
          navigate("/finalresult");
         }
         else if(response?.data?.status=='FAILED')
         {
          SetPendingRequest(false);
          Storage.finalConsentApproval = false;
          Storage.consentpending=false;
          SetStorage(Storage);
          navigate("/finalresult");
         }
         else{
             
          if(Nooftimesapicalled<5)
          {
          // console.log(Nooftimesapicalled);
          // SetNooftimesapicalled(Nooftimesapicalled+1);
          setTimeout(()=>{
            HandleSubmitConsentApprovaltoBackend(Nooftimesapicalled+1);
          },[2000])

         }
         else{
          SetPendingRequest(false);
          Storage.consentpending=true;
          Storage.finalConsentApproval = false;
          SetStorage(Storage);
          navigate("/finalresult");
         }

        }
       

        }
      })
      .catch((error) => {
        navigate("/finalresult");
      });
  };
  const [CheckedData, SetCheckedData] = useState([]);
  const handleChange = (e) => {
    const { value, checked } = e.target;
    // console.log(Bankinfo[value]);
    // SetCheckedData(Bankinfo[value]);
    if(checked)
    {
      SetCheckedData([...CheckedData,Bankinfo[value]]);
    }
    else{

      SetCheckedData(CheckedData.filter(item => item !== Bankinfo[value]));
    }
  };
  const handleConfirmConsent = (e) => {
    mixpanel.track("Interacted_BS_Consent_Page", {
      "Clicked on": "Approve",
      Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
      user_type:localStorage.getItem('user_type')
    });
    e.preventDefault();

  //   HandleSubmitConsentApprovaltoBackend();
 
    ConsentApprovalHeader.sid = Storage.sessionid;
   

   

    const fipdetail = FilterFipDetails(CheckedData);
    // console.log(fipdetail);
    // return ;
    const message = {
      header: ConsentApprovalHeader,
      payload: {
        FIPDetails: fipdetail,

        FIU: {
          id: Storage?.fiu_id,
        },
        ver: "1.1.2",
        consentHandleId: Storage?.consentHandle,
        handleStatus: "ACCEPT",
      },
    };



    const Socketconnnection = Storage.Socketconnnection;
    if(!Socketconnnection)
    {
      localStorage.clear();
       window.open(process.env.REACT_APP_CLOSING_URL, "_self");
    }
    else{
        Socketconnnection.onclose = () => {
          localStorage.removeItem('insession');
          toast.error("Your session is expired. Please try again");
            setTimeout(() => {
                // window.location.href = `/?token=${localStorage.getItem(
                //     "access_token"
                //     )}`;

                localStorage.clear();
      window.open(process.env.REACT_APP_CLOSING_URL, "_self");


                }, 1000);
            };
            
            Socketconnnection.send(JSON.stringify(message));
            
            Socketconnnection.onmessage = (event) => {
                const receivedMessage = JSON.parse(event.data);
                
      if(receivedMessage.payload.status='SUCESS')
       { 

        SetPendingRequest(true);
        setTimeout(() => {
            handleConsentStatus();
        }, 2000);
       }
       else{
        navigate('/finalresult');
       }
            };
        }
        };



        const handleConsentStatus = () => {
    
          ConsenthandleStatusCheck.sid = Storage.sessionid;
         
          const message = {
            header: ConsenthandleStatusCheck,
            payload: {
            handleId: Storage?.consentHandle, 
            },
          };
      
      
          const Socketconnnection = Storage.Socketconnnection;
          if(!Socketconnnection)
          {
            localStorage.clear();
            window.open(process.env.REACT_APP_CLOSING_URL, "_self");
          }
          else{
              Socketconnnection.onclose = () => {
                localStorage.removeItem('insession');
                toast.error("Your session is expired. Please try again");
                  setTimeout(() => {
                      // window.location.href = `/?token=${localStorage.getItem(
                      //     "access_token"
                      //     )}`;

                      localStorage.clear();
                      window.open(process.env.REACT_APP_CLOSING_URL, "_self");

                      }, 1000);
                  };
                  
                  Socketconnnection.send(JSON.stringify(message));
                  
                  Socketconnnection.onmessage = (event) => {
                      const receivedMessage = JSON.parse(event.data);
                      HandleSubmitConsentApprovaltoBackend();
                    //  if(receivedMessage.payload.status=="SUCCESS")
                    //  {



                    //   if(receivedMessage.payload.handleStatus=="READY")
                    //   {
 
                    //     Storage.finalConsentApproval = true;
                    //     Storage.consentpending=false;
                    //     SetStorage(Storage);

                    //     HandleSubmitConsentApprovaltoBackend();
                    //   }
                    //   else if(receivedMessage.payload.handleStatus=='PENDING'){

                    //     Storage.consentpending=true;
                    //     Storage.finalConsentApproval = false;
                    //     SetStorage(Storage);

                    //     HandleSubmitConsentApprovaltoBackend();
                    //   }
                    //   else{

                    //     Storage.finalConsentApproval = false;
                    //     Storage.consentpending=false;
                    //     SetStorage(Storage);

                    //     navigate('/finalresult');
                    //   }
                    // }else{
                    //   navigate('/finalresult');
                    // }
      
              };
            }
          }
const GetStringLastvalues=(AccountNUmber)=>{

  let accn="";
  for(let i=0;i<5;i++)
  {
    // console.log(i);
    accn+='X';
  }
  accn+=AccountNUmber[AccountNUmber.length-4];
  accn+=AccountNUmber[AccountNUmber.length-3];
  accn+=AccountNUmber[AccountNUmber.length-2];
  accn+=AccountNUmber[AccountNUmber.length-1];
  return accn;

}
        
        return (
    <div className="confirmconsent">
      {Pendingrequest?<Loader/>:<></>}
      <div className="consentDetail">
        <h1>CONSENT DETAILS</h1>
        <div className="consentform">
          <p className="field">Consent Requested On</p>
          <p className="value">
            {ConvertDatetoStandard(ConsentDetail?.startTime)}
          </p>

          <p className="field">Purpose</p>
          <p className="value">{ConsentDetail?.Purpose?.Category?.type}</p>

          <p className="field">Periodic</p>
          <p className="value">Information fetch once a day</p>

          <div className="date">
            <div className="from">
              <p className="field">From Date</p>
              <p className="value">
                {ConvertDatetoStandard(ConsentDetail?.DataDateTimeRange?.from)}
              </p>
            </div>
            <div className="to">
              <p className="field">To Date</p>
              <p className="value">
                {ConvertDatetoStandard(ConsentDetail?.DataDateTimeRange?.to)}
              </p>
            </div>
          </div>

          <p className="field">Account Information</p>
          <p className="value">Profile, Summary, Transactions</p>

          <div className="date">
            <div className="from">
              <p className="field">Data Store</p>
              <p className="value">
                Until {ConsentDetail?.DataLife?.value}{" "}
                {ConsentDetail?.DataLife?.unit}
              </p>
            </div>
            <div className="to">
              <p className="field">Consent Expires</p>
              <p className="value">
                {ConvertDatetoStandard(ConsentDetail?.expireTime)}
              </p>
            </div>
          </div>

          <div className="bank_account">
            <h1>ACCOUNTS</h1>
            {Bankinfo?.map((val, key) => {
              return (
                <div className="bank">
               {/* <img src={ImagesURL.get(val.fip_id)!=null?ImagesURL.get(val.fip_id):bank}></img> */}
               <img src={ImagesURL.get(val?.fipId)!=null?ImagesURL.get(val?.fipId):(ImagesURL.get(val?.fipName)!=null?ImagesURL.get(val?.fipName):(val?.entity_icon_uri?val?.entity_icon_uri:bank))}></img>
                  <div className="information">
                    <p className="name">{val?.fipName}</p>
                    <p className="account">{GetStringLastvalues(val?.maskedAccNumber)}</p>
                    <p className="type">{val?.accType}</p>
                  </div>
                  <input
                    type="checkbox"
                    value={key}
                    onChange={handleChange}
                    // checked={Bankinfo[key]==CheckedData[0]}
                  ></input>
                </div>
              );
            })}
          </div>
          <p
            className="addaccount"
            onClick={(e) => {
              mixpanel.track("Interacted_BS_Consent_Page", {
                "Clicked on": "Add Another Account",
                Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
                user_type:localStorage.getItem('user_type')
              });
              e.preventDefault();
              navigate("/selectbank");
              
            }}
          >
            <span className="plus">+</span>
              <span className="addacn">Add Another Account</span>
          </p>
          <div className="submit">
            <button onClick={handleConfirmConsent} disabled={(CheckedData.length==0||Pendingrequest)}>{Pendingrequest?`Please Wait ...`:"Approve"}</button>

          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
